<template>
  <div class="card shadow">
    <div v-if="title" class="title2" v-html="title">
    </div>
    <div class="body">
      <List :text="text"></List>
    </div>
  </div>
</template>

<script>

  import List from "@/components/lists/OrderedList";

  export default {
    name: 'ListCard',
    components: {List},
    props: ['title', 'text'],
    data() {
      return {
      }
    },

    computed: {
    },

    methods: {

    },

    created() {
    }
  }
</script>

<style lang="scss">
@import "src/assets/scss/index";


</style>
